import { render, staticRenderFns } from "./VerPedido.vue?vue&type=template&id=5cfb85d9&"
import script from "./VerPedido.vue?vue&type=script&lang=js&"
export * from "./VerPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports